PJQ.views.budget.SubJobSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'sub-job-settings'),
        enableSubJobsChanged: null
    },
    events: {
        'click .btn-add-sub-job': 'addClicked',
        'click .btn-edit-sub-job': 'editClicked',
        'click .btn-delete-sub-job': 'deleteClicked',
        'click .btn-edit-cost-codes': 'editCostCodesClicked',
        'click .btn-push-erp': 'pushERP',
        'click .btn-pull-erp': 'pullERP',
    },
    beforeFirstRender: function () {
        this.isFetched = false;

        let fnRender = _.bind(function () {
            this.isFetched = true;
            this.render();
        }, this);
        if (this.options.project != null) {
            this.options.project.fetchBudget(_.bind(function (budget) {
                this.budget = budget;
                PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
                    this.erpIntegration = erp;
                    this.options.project.fetchSubJobs(_.bind(function (subJobs) {
                        this.subJobs = subJobs;
                        this.options.project.fetchCostCodes(_.bind(function (costCodes) {
                            this.costCodes = costCodes;
                            if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
                                this.options.project.fetchERPObject(_.bind(function () {
                                    fnRender();
                                }, this));
                            } else {
                                fnRender();
                            }
                        }, this));
                    }, this));
                }, this));
            }, this));
        }
    },
    renderData: function () {
        return {
            erpIntegration: this.erpIntegration,
            project: this.options.project,
            subJobs: this.subJobs,
            costCodes: this.costCodes,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }
        this.renderERP();
        this.renderSubJobTable();
    },
    renderERP: function () {
        if (this.erpIntegration == null || (this.options.project != null && !this.options.project.isERPSynced())) {
            return;
        }

        let pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_SUB_JOBS),
            pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_SUB_JOBS),
            hasUnsynced = null != _.find(this.subJobs.models, function (subJob) {
                let st = subJob.erpSyncStatus();
                return st !== PJQ.constants.integrations.erp.syncStatuses.APPROVED && st !== PJQ.constants.integrations.erp.syncStatuses.SYNCED;
            }), btn = '';
        this.erpButtons = PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
            pushSupported: pushSupported,
            canPush: hasUnsynced,
            disablePushReason: !hasUnsynced ? 'All sub jobs have been pushed to ERP' : '',
            pullSupported: pullSupported,
            status: status
        });

        let badge = PJQ.helpers.erp.getERPBadge(status);
        this.$('.erp-badge').html('<span class="ml-2">' + badge + '</span>');
    },
    pushERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_SUB_JOBS)) {
            this.erpButtons.pushing(true);
            this.erpIntegration.pushSubJobs(this.options.project, _.bind(function (subJobs) {
                this.erpButtons.pushing(false);
                PJQ.notifications.notify.successNotify({
                    message: _.size(subJobs).toString() + ' Sub Jobs pushed to ERP'
                });
                this.render();
            }, this));
        }
    },
    pullERP: function () {
        if (this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_SUB_JOBS)) {
            this.erpButtons.pulling(true);
            this.erpIntegration.pullSubJobs(this.options.project, (subJobs, err) => {
                this.erpButtons.pulling(false);
                if (subJobs == null) {
                    return;
                }

                let newSubJobsCount = _.size(subJobs) - _.size(this.subJobs.models);
                this.subJobs.reset(subJobs);
                PJQ.notifications.notify.successNotify({
                    message: newSubJobsCount.toString() + ' Sub Jobs pulled from ERP'
                });
                this.render();
            });
        }
    },
    renderSubJobTable: function () {
        if (this.dataTable && this.dataTable.dataTable) {
            this.dataTable.dataTable.destroy();
            this.dataTable = null;
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".sub-jobs-table"),
            data: this.subJobs.models,
            rowId: "cid",
            language: {
                zeroRecords: 'Click "Add Sub Job" to create a new Sub Job'
            },
            order: [1, 'asc'],
            onRowDoubleClick: _.bind(function (row) {
                this.editSubJob(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: (row) => {
                            this.editSubJob(row.data());
                        }
                    },
                    {
                        name: 'Edit Cost Codes',
                        onClick: (row) => {
                            this.editCostCodes(row.data());
                        }
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return null == this.budget.lineItems.findWhere({subJobId: row.data().id});
                        },
                        onClick: (row) => {
                            this.deleteSubJob(row.data());
                        }
                    }
                ]
            },
            columns: [
                {
                    "width": "15px",
                    "columnData": "division",
                    "data": null,
                    "title": "",
                    "className": "dt-center",
                    "orderable": false,
                    "searchable": false,
                    "defaultContent": '',
                    "render": (data, type, row) => {
                        if (row.isERPSynced()) {
                            return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                        }
                        return '';
                    }
                },
                {
                    "data": "attributes.name",
                    "title": "Name",
                    "render": (data, type, model) => {
                        return '<a class="btn-edit-sub-job" href="javascript:void(0)">' + data + '</a>';
                    }
                },
                {
                    "data": "attributes.code",
                    "title": "Code"
                },
                {
                    "data": "attributes.description",
                    "title": "Description"
                },
                {
                    "data": "id",
                    "title": "Cost Codes",
                    "render": (data, type, model) => {
                        let costCodeCount = _.size(this.costCodes.where({subJobId: model.id}));
                        return '<a class="btn-edit-cost-codes" href="javascript:void(0)">' + costCodeCount.toString() + ' Cost Codes</a>';
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "className": "p-2",
                    "width": "80px",
                    "render": (data, type, model) => {
                        let canDelete = null == this.budget.lineItems.findWhere({subJobId: model.id}),
                            res = '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info btn-edit-sub-job ml-1 fs-14"><span class="fal fa-pencil"></span></button>';
                        if (canDelete) {
                            res += '<button type="button" class="btn btn-danger btn-delete-sub-job ml-1 fs-14"><span class="fal fa-trash"></span></button>';
                        } else {
                            res += '<button type="button" disabled class="btn btn-danger ml-1 fs-14" title="This sub job has associated budget line items"><span class="fal fa-trash"></span></button>';
                        }
                        return res + '</div>';
                    }
                }
            ]
        });
    },
    addClicked: function () {
        this.editSubJob(null);
    },
    editClicked: function (e) {
        let id = $(e.currentTarget).closest('tr').attr('id');
        if (_.size(id) > 0) {
            let subJob = this.subJobs.get(id);
            if (subJob != null) {
                this.editSubJob(subJob);
            }
        }
    },
    editSubJob: function (subJob) {
        new PJQ.views.budget.EditSubJobModal({
            model: subJob,
            project: this.options.project,
            subJobs: this.subJobs,
            onSave: _.bind(function (subJob) {
                this.subJobs.add(subJob);
                this.renderSubJobTable();
            }, this),
            onDelete: _.bind(function (subJob) {
                this.deleteSubJob(subJob);
            }, this)
        });
    },
    editCostCodesClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr')),
            subJob = row.data();
        this.editCostCodes(subJob);
    },
    editCostCodes: function (subJob) {
        new PJQ.views.budget.CostCodeSettingsModal({
            project: this.options.project,
            subJob: subJob
        });
    },
    deleteClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.dataTable.getRow(target.closest('tr'));
        this.deleteSubJob(row.data());
    },
    deleteSubJob: function (subJob) {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Sub Job?",
            onDelete: _.bind(function () {
                subJob.destroy({
                    notify: false,
                    success: _.bind(function () {
                        this.subJobs.remove(subJob);
                        this.renderSubJobTable();
                    }, this),
                    error: function (model, xhr) {
                        if (xhr.responseJSON != null && xhr.responseJSON.type === 'delete_sub_job_with_line_item') {
                            PJQ.notifications.notify.warningNotify({
                                message: 'This sub job cannot be deleted because it has budget line items associated with it.'
                            });
                        }
                    }
                });
            }, this)
        });
    }
});

PJQ.views.budget.EditSubJobModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-edit-sub-job'),
        maxWidth: 600
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-close': 'close',
        'click .btn-delete': 'delete'
    },
    beforeModalCreated: function () {
        if (this.model == null) {
            this.model = new PJQ.models.budget.SubJob({
                projectId: this.options.project ? this.options.project.id : null
            });
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            isFetched: this.isFetched
        };
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.model, {
            setDefaultValues: true,
            watchElements: [
                'input',
                'select'
            ]
        });
    },
    close: function () {
        if (this.model.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.save();
                }, this),
                onDontSave: _.bind(function () {
                    if (this.options.onClose) {
                        this.options.onClose(this.model);
                    }
                    this.removeModal();
                }, this)
            });
        } else if (this.options.onClose) {
            this.options.onClose(this.model);
            this.removeModal();
        }
    },
    validate: function () {
        let $name = this.$('.input-name'),
            name = $name.val(),
            isNameValid = true,
            errorText = '';
        if (_.size(name) === 0) {
            isNameValid = false;
        } else if (null != _.find(this.options.subJobs.models, function (sj) {
            return sj.id !== this.model.id && sj.get('name').toLowerCase() === name.toLowerCase();
        }, this)) {
            isNameValid = false;
            errorText = 'This sub job name already exists'
        }
        PJQ.helpers.inputHelpers.setInputError($name, isNameValid, {
            errorText: errorText
        });
        return isNameValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function () {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }
                    if (this.options.project != null) {
                        if (this.options.project.subJobs != null) {
                            this.options.project.subJobs.add(this.model);
                        }
                    }
                    this.removeModal();
                    PJQ.notifications.notify.successNotify({
                        message: 'Sub Job saved'
                    });
                }, this)
            });
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this Sub Job?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.removeModal();
            }, this)
        });
    }
});